<template>
  <el-main class="userdetail">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/invoice' }">发票管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户发票详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">项目信息</h3>
      <ul>
        <li>
          <p>
            <label>合同编号：</label><a class="linkwrap normal"><el-link
                @click="link(`/project/detail?id=${invoiceArr.applyArr.projectArr.id}`)">{{
                  invoiceArr.applyArr.projectArr.contract_no }}</el-link></a>
          </p>
          <p>
            <label>客户公司名称：</label><span>{{ invoiceArr.applyArr.client_company }}</span>
          </p>
          <p>
            <label>项目名称：</label><span>{{ invoiceArr.applyArr.projectArr.contract_name }}</span>
          </p>
          <p>
            <label>项目负责人：</label><span>{{ invoiceArr.applyArr.projectArr.manager_name }} {{ invoiceArr.applyArr.projectArr.manager_enname }}</span>
          </p>
          <p>
            <label>项目起止时间</label><span>{{ invoiceArr.applyArr.projectArr.contract_start_time }} —— {{
              invoiceArr.applyArr.projectArr.contract_end_time }}</span>
          </p>
        </li>

        <li>
          <p>
            <label></label>
          </p>

          <p>
            <label>品牌：</label><span>{{ invoiceArr.applyArr.projectArr.brand }}</span>
          </p>
          <p>
            <label>收款计划名称：</label><span>{{ invoiceArr.applyArr.billArr.bill_name ? invoiceArr.applyArr.billArr.bill_name :
              '请填写' }}</span>
          </p>
          <p>
            <label>项目状态：</label><span>{{ dd.pro_status[invoiceArr.applyArr.projectArr.status] }}</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">发票信息</h3>
      <ul>
        <li>
          <p>
            <label>发票号码：</label><a>{{ invoiceArr.invoice_no }}</a>
          </p>
          <p>
            <label>发票类型：</label><span>{{ dd.invoice_type[invoiceArr.applyArr.type] }}</span>
          </p>
          <p>
            <label>税率：</label><span>{{ invoiceArr.applyArr.tax_rate + '%' }}</span>
          </p>
          <p>
            <label>计划收款时间：</label><span>{{ invoiceArr.applyArr.billArr ? (invoiceArr.applyArr.billArr.estimate_date !=
              '0000-00-00' ? invoiceArr.applyArr.billArr.estimate_date : invoiceArr.applyArr.billArr.bill_date) : '暂无'
            }}</span>
          </p>
          <p>
            <label>开票内容：</label><span>{{ dd.category_type[invoiceArr.applyArr.category] }}</span>
          </p>
          <p>
            <label>备注：</label><span>{{ invoiceArr.applyArr.info }}</span>
          </p>
          <p>
            <label>是否收款：</label><span>{{ dd.is_receive[invoiceArr.applyArr.is_receive] }}</span>
          </p>
          <p>
            <label>发票状态：</label>
            <span style="width: 100%">
              <el-col :span="12">{{ dd.invoice_update[invoiceArr.status] }}</el-col>
              <el-col :span="12">
                <el-button round style="text-align: center;" @click="delShow = true"
                  v-if="invoiceArr.status == '1'">作废发票</el-button>
              </el-col>
            </span>
          </p>          
        </li>

        <li>
          <p>
            <label>发票代码：</label><span>{{ invoiceArr.invoice_code }}</span>
          </p>

          <p>
            <label>开票金额：</label><span>{{ invoiceArr.invoice_amount }}</span>
          </p>
          <p>
            <label>税额：</label><span>{{ invoiceArr.invoice_tax }}</span>
          </p>
          <p>
            <label>发票日期：</label><span>{{ invoiceArr.invoice_date }}</span>
          </p>
          <p>
            <label>收款日期：</label><span>{{ invoiceArr.receive_date }}</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">开票信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label><a>{{ invoiceArr.applyArr.client_company }}</a>
          </p>
          <p>
            <label>公司注册地址：</label><a>{{ invoiceArr.applyArr.reg_address }}</a>
          </p>
          <p>
            <label>联系人电话：</label><a>{{ invoiceArr.applyArr.projectArr.phone }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(invoiceArr.applyArr.pay_bank_account)">{{
              invoiceArr.applyArr.pay_bank_account }}</a>
          </p>

        </li>

        <li>
          <p>
            <label>发票代码：</label><span>{{ invoiceArr.applyArr.projectArr.brand }}</span>
          </p>
          <p>
            <label>联系人姓名：</label><span>{{ invoiceArr.applyArr.projectArr.name }}</span>
          </p>
          <p>
            <label>银行名称：</label><span>{{ invoiceArr.applyArr.pay_bank }}</span>
          </p>
          <p>
            <label> 统一社会信用代码：</label><span>{{ invoiceArr.applyArr.company_id_card }}</span>
          </p>

        </li>
      </ul>
    </div>

    <el-dialog title="发票作废提醒" :visible.sync="delShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>发票作废行为不可逆，您是否确定作废该发票</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="invoiceChange">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
export default {
  name: 'invoiceDetail',
  data() {
    return {
      nodeLimtList: [],
      invoiceArr: {
        applyArr: {
          projectArr: {},
          billArr: {},
        }
      },
      total: 0,
      p: 1,
      perPage: 30,
      delShow: false,
    }
  },
  computed: {
    parentActive() {
      return (item) => {
        return item.parent && item.active
      }
    },
    myTrackList() {
      return this.trackList.filter((item) => item)
    },
  },
  created() {
    this.query.id && this.getInvoiceDetail(this.query.id)
  },
  mounted() {

  },
  watch: {
    ['invoiceArr.applyArr.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.invoiceArr.applyArr.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    invoiceChange() {
      this.$fly
        .post('apiSale_updateInvoice.html', {
          invoice_id: this.query.id,
          status: 2
        })
        .then((res) => {
          this.$message.success(res.message)
          this.delShow = false
          this.getInvoiceDetail(this.query.id)
        })
    },
    getInvoiceDetail(id) {
      this.checkUrlFn()
      api.getInvoiceDetail({ invoice_id: id }).then((res) => {
        const taxRate = Number(res.itemArr.applyArr.tax_rate)
        this.invoiceArr = res.itemArr
        this.invoiceArr.invoice_tax = res.itemArr.invoice_tax ? res.itemArr.invoice_tax : (Number(res.itemArr.invoice_amount) / ((100 + taxRate) / 100) * taxRate / 100).toFixed(2) 
      })
    },
    search() {
      this.p = 1
      this.getTrackList()
    },
    handleCurrentChange(p) {
      this.p = p
      this.getTrackList()
    },
    onSubmit() {
      console.log('submit!')
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g, ""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    },
    link(url) {
      this.$router.push(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.userdetail {
  min-width: 1000px;
  .history {
    @extend %box;
    padding: 20px;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }

  .table {
    @extend %box;
    padding: 20px 40px;
    margin-bottom: 20px;
    position: relative;

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--card); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 40%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }

        &:last-child {
          width: 60%;
          box-sizing: border-box;
          padding-left: 85px;
        }
      }
    }

    .for-title {
      font: 700 24px/1.5 $font;
      color: var(--text-1); /* 0819修改 */;
    }

    .for {
      padding: 25px 0;

      &.grey {
        padding: 25px 20px;
        border-radius: 20px;
        background: var(--bg-soft); /* 0819修改 */
        margin-bottom: 20px;
      }

      ul {
        @extend %start;
        color: var(--text-1); /* 0819修改 */;
        background: var(--bg-soft); /* 0819修改 */
        padding: 0 25px;
        border-radius: 20px;
        margin-bottom: 20px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }

        li {
          width: 40%;
          font: 14px/3 $font;

          p {
            height: 42px;
            @extend %start;

            label {
              width: 150px;
              white-space: nowrap;
              flex: none;
            }

            span {
              white-space: nowrap;
            }
          }

          &:last-child {
            width: 60%;
            box-sizing: border-box;
            padding-left: 85px;
          }
        }
      }

      .el-button {
        float: right;
        margin-bottom: 10px;
        position: relative;
      }
    }
  }

  .form {
    padding: 30px;
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 20px;
    background: var(--bg-soft); /* 0819修改 */

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        &:last-of-type {
          padding-left: 0;
          width: 60%;
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 80%;
        }
      }
    }
  }
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 14px;
        color: #606266;
      }
    }
  }
}
</style>
